import {TabsTemplate} from 'components/Common/Tabs/Template';
import {withProps} from 'recompose';

export default withProps({
  tabs: {
    index: '統計',
  },
})(TabsTemplate);
